import {
    ShowCapsFrontPageDL,
    StartCapsGameDL,
    ShuffleCapsGameDL,
    SelectCapAdminDL,
    SelectCapAficionadoDL,
    ResetCapsGameDL,
    EmergencyKickCapsPlayersDL
} from '../DL/Caps';

const MAX_RECONNECT_ATTEMPTS = 10;

// === VARIABLES WS ADMIN ===
let capsAdminSocket = null;
let isCapsAdminConnected = false;
let capsAdminReconnectTimeout = null;
let capsAdminReconnectAttempts = 0;
let isCapsAdminIntentionalDisconnect = false; // Candado anti-bucle

// === VARIABLES WS AFICIONADO ===
let capsSocket = null;
let isCapsConnected = false;
let capsReconnectTimeout = null;
let capsReconnectAttempts = 0;
let isCapsIntentionalDisconnect = false; // Candado anti-bucle

// ==========================================================================
// 🔌 WEBSOCKET: ADMIN
// ==========================================================================
export const ConnectWebSocketForCapsAdmin = (onIncomingMessage, onStatusChange = () => {}) => {
    if (capsAdminSocket || isCapsAdminConnected) return;
    isCapsAdminIntentionalDisconnect = false;

    const connect = () => {
        if (isCapsAdminIntentionalDisconnect) return;
        if (capsAdminReconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
            onStatusChange('error'); return;
        }
        
        capsAdminReconnectAttempts++;
        capsAdminSocket = new WebSocket(`${process.env.REACT_APP_API_URL_WSS}?tipo=superadmin`);
        onStatusChange('connecting');

        capsAdminSocket.onopen = () => {
            isCapsAdminConnected = true;
            capsAdminReconnectAttempts = 0;
            onStatusChange('connected');
        };

        capsAdminSocket.onmessage = (event) => {
            try {
                const msg = JSON.parse(event.data);
                if (msg?.type?.startsWith('caps.')) onIncomingMessage(msg);
            } catch (e) {}
        };

        capsAdminSocket.onclose = () => {
            if (isCapsAdminIntentionalDisconnect) return;
            isCapsAdminConnected = false;
            capsAdminSocket = null;
            onStatusChange('reconnecting');
            capsAdminReconnectTimeout = setTimeout(connect, 2000);
        };
        capsAdminSocket.onerror = () => {
            if (!isCapsAdminIntentionalDisconnect) onStatusChange('error');
        };
    };
    connect();
};

export const DisconnectWebSocketForCapsAdmin = () => {
    isCapsAdminIntentionalDisconnect = true;
    if (capsAdminSocket) {
        capsAdminSocket.onclose = null;
        capsAdminSocket.onmessage = null;
        try { capsAdminSocket.close(); } catch (e) {}
    }
    capsAdminSocket = null;
    isCapsAdminConnected = false;
    clearTimeout(capsAdminReconnectTimeout);
    capsAdminReconnectAttempts = 0;
};

// ==========================================================================
// 🔌 WEBSOCKET: AFICIONADO
// ==========================================================================
export const ConnectCapsWebSocket = async (onIncomingMessage, onStatus = () => {}, onToast = () => {}) => {
    if (capsSocket || isCapsConnected) return;
    isCapsIntentionalDisconnect = false;

    const connect = () => {
        if (isCapsIntentionalDisconnect) return;
        if (capsReconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
            onStatus('error'); return;
        }
        
        capsReconnectAttempts++;
        capsSocket = new WebSocket(`${process.env.REACT_APP_API_URL_WSS}?tipo=caps:aficionado`);
        onStatus('connecting');

        capsSocket.onopen = () => {
            isCapsConnected = true;
            capsReconnectAttempts = 0;
            onStatus('connected');
            onToast('Conectado a la dinámica 🧢');
        };

        capsSocket.onmessage = (event) => {
            try { onIncomingMessage(JSON.parse(event.data)); } catch (e) {}
        };

        capsSocket.onclose = () => {
            if (isCapsIntentionalDisconnect) return;
            isCapsConnected = false;
            capsSocket = null;
            onStatus('reconnecting');
            capsReconnectTimeout = setTimeout(connect, 2000);
        };

        capsSocket.onerror = () => {
            if (!isCapsIntentionalDisconnect) onStatus('error');
        };
    };
    connect();
};

export const DisconnectCapsWebSocket = () => {
    isCapsIntentionalDisconnect = true;
    if (capsSocket) {
        capsSocket.onclose = null;
        capsSocket.onmessage = null;
        try { capsSocket.close(); } catch (e) {}
    }
    capsSocket = null;
    isCapsConnected = false;
    clearTimeout(capsReconnectTimeout);
    capsReconnectAttempts = 0;
};

// ==========================================================================
// 📡 PUENTE REST API (Exponiendo al UI)
// ==========================================================================
export const ShowCapsFrontPageBL = async () => await ShowCapsFrontPageDL();
export const StartCapsGame = async (config) => await StartCapsGameDL(config);
export const ShuffleCapsGame = async () => await ShuffleCapsGameDL();
export const SelectCapAdmin = async (capId) => await SelectCapAdminDL(capId);
export const SelectCapAficionadoBL = async (capId) => await SelectCapAficionadoDL(capId);
export const ResetCapsGame = async () => await ResetCapsGameDL();
export const EmergencyKickCapsPlayers = async () => await EmergencyKickCapsPlayersDL();